import Page from "../common/page";

import SiteData from "/setting/site-data";
import * as onlineItem from '/src/ejs/component/component-shop-online-item.ejs';
import * as offlineItem from '/src/ejs/component/component-shop-offline-item.ejs';
import {HtmlUtil} from "../utils/HtmlUtil";

export default class PageShop extends Page {
    setPage() {
        //data load 후 el 구성
        if (SiteData.isHtmlTest) return;
        console.log(this.data);
        console.log(onlineItem);

        this.setShopContainer(
            this.el.querySelector('.sec-1 .shop-container'),
            this.data.page.data.online,
            onlineItem()
        );

        this.setShopContainer(
            this.el.querySelector('.sec-2 .shop-container'),
            this.data.page.data.offline,
            offlineItem()
        );
    }

    setShopContainer(el, data, ejsTemplate) {
        el.innerHTML = '';
        data.forEach(
            (data)=>{
                let element = HtmlUtil.getEjsElement(ejsTemplate, data);
                el.appendChild(element);
            }
        )
    }
}
